import React from "react";
import type { LucideIcon } from "lucide-react";

interface StatTileProps {
  title: string;
  value: string | number;
  icon: LucideIcon;
  iconColor?: string;
  valueColor?: string;
}

/** Flat single-div stat tile — the salesforce-release page's own take on the
 *  `StatCard` recipe used by the Git page (`components/molecules/git/shared.tsx`),
 *  kept local so it doesn't touch the shared `MetricCard` (also used by the
 *  Security Scanner). */
export const StatTile: React.FC<StatTileProps> = ({
  title,
  value,
  icon: Icon,
  iconColor = "text-muted-foreground",
  valueColor = "",
}) => {
  return (
    <div className="rounded-lg border border-border/60 bg-muted/20 px-4 py-3">
      <div className="mb-1 flex items-center justify-between gap-2">
        <span className="truncate text-[10px] font-semibold uppercase tracking-wide text-muted-foreground">
          {title}
        </span>
        <Icon className={`h-3.5 w-3.5 shrink-0 ${iconColor}`} />
      </div>
      <div className={`text-xl font-bold ${valueColor}`}>{value}</div>
    </div>
  );
};

export default StatTile;
